export default __webpack_public_path__ + "static/media/sports-cat.7537139c.webp";